export default __webpack_public_path__ + "static/media/ic_inbox_0.c0576566.svg";